import { createAsyncThunk } from "@reduxjs/toolkit";
import VisitorsEventService from "../../services/VisitorsEvents/VisitorsEventsService";

export const getVisitorEvents = createAsyncThunk(
  "visitor/events",
  async (payload) => {
    const res = await VisitorsEventService.getVisitorsEvents();
    return res.data;
  }
);

export const clearNotifications = createAsyncThunk(
  "visitor/events",
  async (payload) => {
    const res = await VisitorsEventService.clearNotifications();
    return res.data;
  }
);
